import { Box, Button } from "@mui/material";
import React, { useState } from "react";
import BlurOnIcon from "@mui/icons-material/BlurOn";
import UiText from "../../UI/ui-text/UiText";
import UiPass from "../../UI/ui-text/UiPass";
import KeyboardBackspaceRoundedIcon from "@mui/icons-material/KeyboardBackspaceRounded";
import RemoveRoundedIcon from "@mui/icons-material/RemoveRounded";
import AXIOS from "../../Axios";

const LoginPage = (propse) => {
  const [Email, setEmail] = useState("sara456@yahoo.com");
  const [Password, setPassword] = useState("123");
  const [Error1, setError1] = useState("");
  const [Error2, setError2] = useState("");
  const OnChange = (e, event) => {
    if (e === "EMAIL") {
      setEmail(event.target.value);
      setError1(false);
    }
    if (e === "PASSWORD") {
      setPassword(event.target.value);
      setError2(false);
    }
  };
  const onClick = (e) => {
    if (e === "EMAIL") {
      setEmail("");
      setError1(false);
    }
    if (e === "PASSWORD") {
      setPassword("");
      setError2(false);
    }
    if (e === "BACK") {
      propse.setRegister(false);
      propse.setLogin(false);
    }
  };
  function isValidEmail(email) {
    return /\S+@\S+\.\S+/.test(email);
  }
  const onSubmit = async (event) => {
    event.preventDefault();
    let EMAILS = [];
    let PASSWORDS = [];
    let formIsValid = true;
    if (Email.trim().length === 0 || !isValidEmail(Email)) {
      setError1(true);
      formIsValid = false;
    }
    if (Password.trim().length === 0) {
      setError2(true);
      formIsValid = false;
    }
    if (formIsValid) {
      propse.setLoading(true);
      const DATA = {
        EMAIL: Email.trim(),
        PASSWORD: Password.trim(),
      };
      propse.setEmailRepeat(Email);
      await AXIOS.get("/LB.json")
        .then((response) => {
          if (response.status === 200) {
            if (response.data === null) {
              propse.setShowModal({
                SHOW: true,
                PM1: "This",
                PM2: Email,
                PM3: "is NOT available in the database!",
              });
            } else {
              const myArray = Object.entries(response.data.REGISTER);
              for (let x in myArray) {
                let index = EMAILS.indexOf(myArray[x][1].EMAIL);
                if (index === -1) {
                  EMAILS.push(myArray[x][1].EMAIL);
                  PASSWORDS.push(myArray[x][1].PASSWORD);
                }
              }
              let index = EMAILS.indexOf(Email.trim().toLowerCase());
              if (index === -1) {
                propse.setShowModal({
                  SHOW: true,
                  PM1: "This",
                  PM2: Email,
                  PM3: "is NOT available in the database!",
                });
              } else {
                if (PASSWORDS[index] === Password) {
                  propse.setisLogged(true);
                } else {
                  propse.setShowModal({
                    SHOW: true,
                    PM1: "This",
                    PM2: "PASSWORD",
                    PM3: "is NOT Correct!",
                  });
                }
              }
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };
  return (
    <React.Fragment>
      <form onSubmit={onSubmit}>
        <Box sx={{ width: propse.Width < 560 ? "100%" : "90%" }}>
          {propse.Width >= 560 ? (
            <Box>
              <Box
                sx={{
                  width: "38px",
                  height: "38px",
                  backgroundColor: "rgba(90,90,90,0.1)",
                  borderRadius: "50%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                  color: "rgba(70,70,70)",
                }}
              >
                <BlurOnIcon />
              </Box>
              <Box
                sx={{
                  marginTop: "-30px",
                  marginLeft: "48px",
                  fontSize: "1.2rem",
                  color: "#000",
                }}
              >
                login
              </Box>
            </Box>
          ) : null}
          <Box
            sx={{
              height: "90px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",

              // fontFamily: "Poppins",
              // color: "rgba(70,70,70)",
            }}
          >
            <Box sx={{ fontSize: "0.9rem" }}>Please Login To </Box>
            <Box sx={{ fontSize: "1.6rem" }}>Your Profile</Box>
          </Box>
          <Box
            sx={{
              width:
                propse.Width < 560 ||
                (propse.Width >= 560 && propse.Width < 768)
                  ? "100%"
                  : "70%",
            }}
          >
            <UiText
              ID="EMAIL"
              Value={Email}
              Lable="Email"
              Error={Error1}
              OnChange={(e) => OnChange("EMAIL", e)}
              onClick={() => onClick("EMAIL")}
            />
            <UiPass
              ID="PASSWORD"
              Value={Password}
              Lable="Password"
              Error={Error2}
              OnChange={(e) => OnChange("PASSWORD", e)}
            />
            <Box sx={{ height: "93px" }}></Box>
            {propse.Loading ? (
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#ed013e",
                  width: propse.Width < 560 ? "100%" : "150px",
                  height: "45px",
                  fontFamily: "Poppins",
                  fontSize: "0.8rem",
                  fontWeight: "bold",
                  zIndex: "6",
                  marginTop:
                    propse.Width < 560 ? "calc(100vh - 462px)" : "20px",
                  display: "flex",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#ed013e")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor = "#ed013e")
                }
              >
                <i
                  className="fa fa-spinner fa-spin"
                  style={{ marginRight: "7px" }}
                ></i>
                Loading
              </Button>
            ) : (
              <Button
                variant="contained"
                type="submit"
                sx={{
                  backgroundColor: "#ed013e",
                  width: propse.Width < 560 ? "100%" : "150px",
                  height: "45px",
                  fontFamily: "Poppins",
                  fontSize: "0.8rem",
                  fontWeight: "bold",
                  zIndex: "6",
                  marginTop:
                    propse.Width < 560 ? "calc(100vh - 462px)" : "20px",
                  display: "flex",
                }}
                onMouseEnter={(e) =>
                  (e.target.style.backgroundColor = "#ed013e")
                }
                onMouseLeave={(e) =>
                  (e.target.style.backgroundColor = "#ed013e")
                }
              >
                LOGIN
              </Button>
            )}

            <Box
              sx={{
                width: "150px",
                height: "45px",
                display: propse.Width < 560 ? "none" : "flex",
                flexDirection: "row",
                justifyContent: "center",
                textAlign: "center",
                alignItems: "center",
                marginTop: "-40px",
                marginLeft: "130px",
                color: "rgba(70,70,70)",
              }}
            >
              <Box sx={{ cursor: "pointer" }} onClick={() => onClick("BACK")}>
                <KeyboardBackspaceRoundedIcon />
                <RemoveRoundedIcon sx={{ marginLeft: "-4px" }} />
              </Box>
            </Box>
          </Box>
        </Box>
      </form>
    </React.Fragment>
  );
};

export default LoginPage;
